import { atom } from 'jotai';

// Atom for external account
export const externalAccountAtom = atom<string | null>(null);
externalAccountAtom.debugLabel = 'externalAccountAtom';

// Atom for event account params
export const eventAccountParamsAtom = atom<string | null>(null);
eventAccountParamsAtom.debugLabel = 'eventAccountParamsAtom';
